var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#485158"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97718 2.77246L7.91051 3.77246C8.00108 3.8695 8.02545 4.01101 7.97255 4.13275C7.91964 4.25448 7.79956 4.33323 7.66683 4.33323H2.3335V3.66657H6.89976L6.48981 3.22734L6.97718 2.77246Z",
    fill: "#CAD5DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35631 7.22754L2.42298 6.22754C2.33242 6.1305 2.30805 5.98898 2.36095 5.86725C2.41385 5.74551 2.53393 5.66677 2.66667 5.66677H8V6.33343H3.43374L3.84369 6.77266L3.35631 7.22754Z",
    fill: "#CAD5DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switch-icon.4d6cedbdb66293a89c10727d92ab4af2.svg";
export { ForwardRef as ReactComponent };